module.exports = __webpack_public_path__ + "static/environment-ca03adc1e46c71e24099efb24e55df81.svg";